import { Switch, Space } from "antd";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../../../contexts/auth/AuthContext";
import useSettings from "../../../../hooks/useSettings";
import hasPermission from "../../../../utils/hasPermission";

export default function SwitchSettings() {
  const { t } = useTranslation();
  const [settings, setSettings] = useSettings();
  const { authState } = useContext(AuthContext);

  function changeNotification(
    type: "moneyChat" | "orderChat" | "order",
    val: boolean
  ) {
    const newSettings = settings;
    newSettings.notifications[type] = val;

    setSettings(newSettings);
  }

  return (
    <Space>
      <Switch
        onChange={(val) => changeNotification("moneyChat", val)}
        checked={settings?.notifications.moneyChat}
        checkedChildren={t("money")}
        unCheckedChildren={t("money")}
      />
      <Switch
        onChange={(val) => changeNotification("orderChat", val)}
        checked={settings?.notifications.orderChat}
        checkedChildren={t("orderChat")}
        unCheckedChildren={t("orderChat")}
      />
      <Switch
        onChange={(val) => setSettings({...settings, toolbar: val})}
        checked={settings?.toolbar}
        checkedChildren={t("toolbar")}
        unCheckedChildren={t("toolbar")}
      />
      {hasPermission(authState.user, "/orders") && (
        <Switch
          onChange={(val) => changeNotification("order", val)}
          checked={settings?.notifications.order}
          checkedChildren={t("orders")}
          unCheckedChildren={t("orders")}
        />
      )}
    </Space>
  );
}
